import { render, staticRenderFns } from "./Step3A.vue?vue&type=template&id=3bf71ab2"
import script from "./Step3A.vue?vue&type=script&lang=js"
export * from "./Step3A.vue?vue&type=script&lang=js"
import style0 from "./Step3A.vue?vue&type=style&index=0&id=3bf71ab2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports